sn-asks-type-1 {
  // Layout styles copied from features-type-8
  .sn-asks__cards {
    display: flex;
    align-items: stretch;
    flex-direction: column;
    gap: var(--spacing-md);

    @include desktop {
      flex-direction: row;
      gap: var(--spacing-4xl);
    }

    > * {
      flex: 1 1 0;
      min-width: 0;
    }
  }

  me-heading {
    margin-bottom: px-to-rem(12px);
    text-align: center;

    @include above(768px) {
      margin-bottom: px-to-rem(16px);
    }

    @include above(1200px) {
      margin-bottom: px-to-rem(22px);
    }
  }

  me-text {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: px-to-rem(28px);
    text-align: center;
    font-size: px-to-rem(14px);
    line-height: px-to-rem(24px);

    @include above(768px) {
      margin-bottom: px-to-rem(34px);
      font-size: px-to-rem(16px);
      line-height: px-to-rem(28px);
    }

    @include above(960px) {
      margin-bottom: px-to-rem(38px);
      max-width: 70%;
    }

    @include above(1200px) {
      margin-bottom: px-to-rem(42px);
      font-size: px-to-rem(20px);
      line-height: px-to-rem(32px);
    }
  }

  // Backward compat: old template data wraps cards in <a class="sn-asks__link">
  .sn-asks__link {
    display: block;
    text-decoration: none;
    color: inherit;

    &:hover {
      me-heading[slot='heading'] .me-heading {
        color: #0777cf;
      }
    }
  }

  // New format: href on features-card-type-6 renders inner <a class="features-card-type-6__link">
  .features-card-type-6__link {
    &:hover {
      me-heading[slot='heading'] .me-heading {
        color: #0777cf;
      }
    }
  }

  // Override features-card-type-6 styles
  .features-card-type-6 {
    border: none;

    .features-card-type-6__icon {
      max-width: 300px;
      margin-left: auto;
      margin-right: auto;

      @include desktop {
        max-width: none;
        margin-left: 0;
        margin-right: 0;
      }
    }

    me-heading[slot='heading'] {
      margin-bottom: 0;
      font-size: px-to-rem(16px);
      line-height: px-to-rem(24px);
      font-weight: 700;
      color: #2c2c2c;

      @include above(768px) {
        font-size: px-to-rem(20px);
        line-height: px-to-rem(28px);
      }

      @include above(1200px) {
        font-size: px-to-rem(24px);
        line-height: px-to-rem(32px);
      }
    }

    me-text[slot='description'] {
      font-size: px-to-rem(14px);
      line-height: px-to-rem(24px);
      color: #2c2c2c;
    }
  }
}
